import React from 'react';
import styled from 'styled-components';
import { ResponseContainer } from './DisplayContainer';
import { Box as MuiBox, useTheme } from '@mui/material';
import { StarRounded, StarBorderRounded } from '@mui/icons-material';

const RatingDisplay = (props) => {
  const theme = useTheme()
  const { value } = props;
  const stars = 5;

  return (
    <ResponseContainer>
      <SMuiBox>
        {Array(stars)
          .fill()
          .map((_, i) =>
            i < value ? (
              <StarRounded key={i} sx={{ color: theme.palette.colors.blue100 }} />
            ) : (
              <StarBorderRounded key={i} sx={{ color: theme.palette.colors.gray }} />
            )
          )}
      </SMuiBox>
    </ResponseContainer>
  );
};

export default RatingDisplay;

const SMuiBox = styled(MuiBox)`
  && {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: left;
  }
`;
